<template>
    <div>
        <v-card flat min-height="100%">
            <v-card-text class="pa-md-8">
                <v-subheader class="font-weight-bold pa-0 primary--text">User directory</v-subheader>
                <v-card flat outlined min-height="100%">
                    <v-toolbar flat>
                        <v-text-field
                            hide-details
                            prepend-inner-icon="mdi-magnify"
                            single-line
                            solo flat dense outlined
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn icon color="accent" @click="edit_user.open = true">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </v-toolbar>
                </v-card>
            </v-card-text>
        </v-card>
        <formUser :open="edit_user.open" :user="edit_user.user" @close="updateFormUser()"/>
        <formDelete :open="delete_user.open" :user="delete_user.user" @close="deleteForm()" />
    </div>
</template>

<script>
import { LEVEL_ADMIN, userAtLeastIs } from '../../plugins/checkPermission.js'
import formUser from './formUser.vue'
import formDelete from './formDelete'
export default {
    name: 'users',
    components: { formUser, formDelete },
    data() {
        return {
            LEVEL_ADMIN,
            open_new_user: false,
            edit_user: {
                open: false,
                user: null 
            },
            users: ['Eme1', 'Eme2', 'Eme3'],
            delete_user: {
                open: false,
                user: null
            },
            filter: '',
            users_filtered: [],
            users_with_plants: [],
        }
    },
    methods: {
        userAtLeastIs,
        updateFormUser(id){
            this.edit_user.user = id ? this.users.find( u => u.id == id): null
            this.edit_user.open = id ? true : false
            this.openEdit = false
        },
        deleteForm(id){
            this.delete_user.user = id ? id : null
            this.delete_user.open = id ? true : false
            if(!id) this.updateUsersPlants()
        },
    },
}
</script>